module.exports = {
	"ha": "viha",
	"id": 5.4,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by MSM Status, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 98.44097995545657,
						"dataLabels": {
							"enabled": true,
							"format": "442"
						}
					},
					{
						"y": 96.88195991091314,
						"dataLabels": {
							"enabled": true,
							"format": "435"
						}
					},
					{
						"y": 92.87305122494432,
						"dataLabels": {
							"enabled": true,
							"format": "417"
						}
					},
					{
						"y": 88.41870824053451,
						"dataLabels": {
							"enabled": true,
							"format": "397"
						}
					},
					{
						"y": 65.70155902004454,
						"dataLabels": {
							"enabled": true,
							"format": "295"
						}
					},
					{
						"y": null
					},
					{
						"y": 99.35064935064936,
						"dataLabels": {
							"enabled": true,
							"format": "306"
						}
					},
					{
						"y": 99.35064935064936,
						"dataLabels": {
							"enabled": true,
							"format": "306"
						}
					},
					{
						"y": 99.02597402597402,
						"dataLabels": {
							"enabled": true,
							"format": "305"
						}
					},
					{
						"y": 92.20779220779221,
						"dataLabels": {
							"enabled": true,
							"format": "284"
						}
					},
					{
						"y": 61.038961038961034,
						"dataLabels": {
							"enabled": true,
							"format": "188"
						}
					},
					{
						"y": null
					},
					{
						"y": 95.77464788732394,
						"dataLabels": {
							"enabled": true,
							"format": "340"
						}
					},
					{
						"y": 88.73239436619718,
						"dataLabels": {
							"enabled": true,
							"format": "315"
						}
					},
					{
						"y": 87.04225352112675,
						"dataLabels": {
							"enabled": true,
							"format": "309"
						}
					},
					{
						"y": 80.84507042253522,
						"dataLabels": {
							"enabled": true,
							"format": "287"
						}
					},
					{
						"y": 61.69014084507042,
						"dataLabels": {
							"enabled": true,
							"format": "219"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -1.5590200445434244,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.5837104072398245,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.137931034482756,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.796163069544368,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.692695214105797,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.649350649350644,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.32679738562091387,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.8852459016393475,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.80281690140845,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.225352112676061,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.352941176470584,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.904761904761909,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.119741100323629,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.69337979094077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=449"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=308"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=355"
			}
		],
		"dataTable": {
			"MSM": [
				449,
				442,
				435,
				417,
				397,
				295
			],
			"Non-MSM": [
				308,
				306,
				306,
				305,
				284,
				188
			],
			"Unknown": [
				355,
				340,
				315,
				309,
				287,
				219
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_4.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_4.json
// module id = 339
// module chunks = 0